import { api, type VoidPreview } from './api'
import { money } from './format'

/**
 * 作廢驗收單的完整互動流程（列表頁與列印頁共用）
 *
 * 兩段確認是刻意的：
 *   第一段用後端算出來的真實影響列出代價，讓人「看見」會發生什麼；
 *   第二段必填原因，製造一點摩擦逼人停一秒，順便留下稽核。
 *
 * @returns true 代表已作廢（呼叫端該重新載入），false 代表使用者取消或被擋下
 */
export async function voidAcceptance(id: number, onError: (msg: string) => void): Promise<boolean> {
  let p: VoidPreview
  try {
    p = await api.get<VoidPreview>(`/acceptances/${id}/void-preview`)
  } catch (e: any) {
    onError(e.message)
    return false
  }

  if (!p.can_void) {
    onError(`無法作廢 ${p.code}：${p.blockers.join('；')}`)
    return false
  }

  const bills = p.billings_to_delete
  const qty = p.accepted_qty_revert.reduce((n, r) => n + r.n, 0)
  const lines = [
    `確定要作廢驗收單 ${p.code}（發包單 ${p.work_order_code}）？`,
    '',
    `• 刪除 ${bills.length} 筆請款明細，共 ${money(bills.reduce((n, b) => n + b.amount, 0))} 元`,
    `• 扣回已驗收 ${qty} 篇`,
    `• 發包單狀態：${p.status_from} → ${p.status_to}`,
  ]
  if (p.revise_count_from !== p.revise_count_to) {
    lines.push(`• 退修次數：${p.revise_count_from} → ${p.revise_count_to}`)
  }
  if (!p.snapshot_used) {
    lines.push('• 此單建立於作廢功能上線前，沒有狀態快照，還原狀態為系統推算')
  }
  lines.push('', '驗收單紀錄會保留並標記為已作廢，但此動作無法復原。')

  if (!confirm(lines.join('\n'))) return false

  const reason = prompt('請填寫作廢原因（會記錄在稽核紀錄中）')
  if (reason === null) return false
  if (reason.trim().length < 2) {
    onError('作廢原因至少需要 2 個字')
    return false
  }

  try {
    const res = await api.post<{ void_warning?: string | null }>(`/acceptances/${id}/void`, {
      reason: reason.trim(),
    })
    if (res.void_warning) onError(res.void_warning)
    return true
  } catch (e: any) {
    onError(e.message)
    return false
  }
}
